import Marquee from "react-fast-marquee";
import { BRAND } from "@/config";

export default function AnnouncementBar() {
  return (
    <div className="hazard-stripes-thin py-[3px]" data-testid="announcement-bar">
      <div className="bg-yaza-accent py-2 text-xs font-bold uppercase tracking-[0.25em] text-black">
        <Marquee speed={45} autoFill gradient={false}>
          <span className="px-8">{BRAND.tagline}</span>
          <span className="px-8">✕</span>
        </Marquee>
      </div>
    </div>
  );
}
